







































import { Component, Watch } from 'vue-property-decorator';
import Form from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import UserApi from '@/services/rest/bemob/user';
import store from '@/store';
import BillingApi from '@/services/rest/bemob/billing';

type WarningState =  null | 30 | 50 | 70 | 100 | 'blocked'

@Component({
  components: {
    FormOverlay,
    DialogForm,
  }
})

export default class FreeEventsLimit extends Form {
  active: boolean = false;
  tachometerIcon: string = '';
  tachometerColor: string = '';
  title: string = '';
  modalTitle: string = '';
  text: string = '';
  cancelIcon: string = '';
  cancelText: string = '';
  warningState: WarningState;
  userApi: UserApi = new UserApi();
  billingApi: BillingApi = new BillingApi();

  billing = {} as Billing.Subscription;

  get isAllowCloseButton() {
    return ([30,50,70] as WarningState[]).includes(this.warningState)
  }

  warningStateCalculate() {
    const {
      eventsUsed,
      eventsIncluded,
    } = this.$store.state.billing;
    
    const percent = eventsUsed * 100 / eventsIncluded;
    const warningStateCookie = this.$cookies.get('hide-dialog-limit-is-reached') as string;
    const {blockedCampaigns} = this.$store.state.user;
    
    if (blockedCampaigns) {
      return 'blocked';
    }

    if (percent >= 100) {
      return 100;
    }

    if (percent <= 100 && percent >= 70 && !['70'].includes(warningStateCookie)) {
      return 70;
    }

    if (percent < 70 && percent >= 50 && !['50','70'].includes(warningStateCookie)) {
      return 50;
    }

    if (percent < 50 && percent >= 30 && !['30','50','70'].includes(warningStateCookie)) {
      return 30;
    }

    return null;
  }
  
  @Watch('$store.state.billing')
  onBillingChanged() {
    this.warningStateUpdate()
  }

  @Watch('$store.state.panelBlocked')
  async onIsPanelBlockedChanged () {
    const user = this.userApi.getUser()
    store.commit('updateUser', user);

    await this.billingApi.getSubscriptions();

    this.warningStateUpdate()
  }
  
  warningStateUpdate(){
    const { hasSuccessPayment, hideEventsLimitIsReached} = this.$store.state.user;

    if (hasSuccessPayment === 1 || hideEventsLimitIsReached) {
      return this.active = false;
    }

    this.warningState = this.warningStateCalculate();

    if(this.warningState){
      this.updateText()
      this.active = true;
      this.$nextTick(()=> {
        const subscriptionLink = document.querySelector('#goToSubscription');
        if(subscriptionLink){
          subscriptionLink.addEventListener('click',this.goToSubscription)
        }
      })
    }else {
      this.active = false;
    }
  }

  updateText() {
    switch (this.warningState){
      case 30: {
        this.modalTitle = this.t('Overage Notice');
        this.tachometerIcon = 'fa-tachometer-alt-slow';
        this.cancelIcon = 'fas fa-times';
        this.cancelText = this.t('Not Now');
        this.title = this.t('You have used more than 30 000 of free events.');
        this.text = this.t('On {0} plan you are provided with 100 000 free events on 30 days.<br>The traffic in your campaigns will be stopped, if all the free events are used until the end of your billing period.<br>Upgrade the subscription to continue tracking your campaigns with BeMob.<br>To see the exact amount of used events visit the <button id="goToSubscription">Subscription</button> section.<br>Contact our live chat support if you have any questions concerning your subscription.',[this.$store.state.billing.planId]);
        return this.tachometerColor = this.$colors.green;
      }
      case 50: {
        this.modalTitle = this.t('Overage Notice');
        this.tachometerIcon = 'fa-tachometer-alt-average';
        this.cancelIcon = 'fas fa-times';
        this.cancelText = this.t('Not Now');
        this.title = this.t('You have used more than 50 000 of free events.');
        this.text = this.t('On {0} plan you are provided with 100 000 free events on 30 days.<br>The traffic in your campaigns will be stopped, if all the free events are used before your billing period ends.<br>Upgrade the subscription to continue tracking your campaigns with BeMob.<br>To see the exact amount of used events visit the <button id="goToSubscription">Subscription</button> section.<br>Contact our live chat support if you have any questions concerning your subscription.',[this.$store.state.billing.planId]);
        return this.tachometerColor = this.$colors.blue;
      }
      case 70: {
        this.modalTitle = this.t('Overage Notice');
        this.tachometerIcon = 'fa-tachometer-alt-fast';
        this.cancelIcon = 'fas fa-times';
        this.cancelText = this.t('Not Now');
        this.title = this.t('You have used more than 70 000 of free events.');
        this.text = this.t('On {0} plan you are provided with 100 000 free events on 30 days.<br>The traffic in your campaigns will be stopped, if all the free events are used until the end of your billing period.<br>Upgrade the subscription to continue tracking your campaigns with BeMob.<br>To see the exact amount of used events visit the <button id="goToSubscription">Subscription</button> section.<br>Contact our live chat support if you have any questions concerning your subscription.',[this.$store.state.billing.planId]);
        return this.tachometerColor = this.$colors.sunglow;
      }
      case 100: {
        this.modalTitle = this.t('Overage Notice');
        this.tachometerIcon = 'fa-tachometer-alt-fastest';
        this.title = this.t('You reached the limit of free events.');
        this.text = this.t('Upgrade the subscription to continue your work with BeMob as the traffic will be paused soon.<br>Contact our live chat support if you have any further questions.');
        return this.tachometerColor = this.$colors.red;
      }
      case 'blocked': {
        this.modalTitle = this.t('Traffic Stopped');
        this.tachometerIcon = 'fa-user-lock';
        this.title = this.t('Free events finished.');
        this.text = this.t(`Traffic in your campaigns is stopped as you have used all the free events.<br>Upgrade subscription to continue your work with BeMob.<br>Traffic will be automatically resumed after the subscription cost is paid.`);
        return this.tachometerColor = this.$colors.red;
      }
    }}

  beforeDestroy() {
     document.querySelector('#goToSubscription')?.removeEventListener('click',this.goToSubscription);
  }

  close() {
    if(this.isAllowCloseButton){
      this.active = false;
      this.$cookies.set('hide-dialog-limit-is-reached',this.warningState, { expires: '72h' })
    }
  }

  actionBeforeLogout(){
    this.$emit('close');
  }

  goToSubscription() {
    if(this.isAllowCloseButton){
      this.close();
      this.$router.push('/app/profile/subscription')
    }else{
      this.active = false;
      this.bus.emit('open-dialog',{
        name: 'ChangePlanDialog',
        data: {
          registration:true,
          dontClose:true
        }
      });
    }
  }
}
